import styled from 'styled-components/macro';
import { FlexNoAlign } from '../../../../shared-styles/flex';

export const SmartFiltersContainer = styled.div`
  ${FlexNoAlign}
  gap: ${({ theme }) => theme.spacing(20)};
`;
